<template>
	<div>
		<div class="-wrapper">
			<div class="-wrapper v-center-" style="width: 100%">
				<div class="-search-bar" style="width: 100%">
					<span class="-search-icon">
						<span class="material-icons">search</span>
					</span>
					<input type="search" v-model="srchText" @keyup="fnSearching" style="width: 100%" class="-search" :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')">
					<button type="button" class="-btn borderless- small- icon-only-" v-bind:class="srchText == '' ? 'close-' : ''" @click="srchText = '';fnSearching()">
						<span class="material-icons">close</span>
					</button>
				</div>
			</div>
		</div>
		<div>
			<table class="tbl-default" data-linkable-row>
				<caption></caption>
				<colgroup>
					<col style="width: 520px">
					<col>
				</colgroup>
				<thead>
				<tr>
					<th scope="col">
						<div class="float-left">
							<span>
								<input ref="checkAll" type="checkbox" id="check-all" class="checkbox txt-none" v-model="isCheckAll" @click="onCheckAll">
								<label for="check-all" class="vertical-align-baseline"></label>
							</span>
							<button type="button" class="buttons-tbl-header"
								v-bind:data-type="sortNum === 1 ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
								v-on:click="callSetSortColumn(sortNum)">{{ $t('POLICY.LABEL.POLICY_TITLE') }}<!--규칙 이름-->
							</button>
						</div>
					</th>
					<th scope="col">
						<span class="float-left">{{ $t('POLICY.LABEL.POLICY_DESCRIPTION') }}</span>
					</th>
				</tr>
				</thead>
			</table>
			<div-loading v-if="isLoading"/>
			<div v-else class="table-rule">
				<table class="tbl-default" data-linkable-row>
					<colgroup>
						<col style="width: 520px">
						<col>
					</colgroup>
					<tbody>
					<tr v-if="plcyList.length == 0">
						<td colspan="2">
							<p v-if="plcyList.length == 0" class='overlay-nodata'><span>{{$t('COMMON.NO_DATA')}}</span></p>
						</td>
					</tr>
					<tr v-else v-for="(item, index) of plcyList" 
						:key="index"
						style="cursor:pointer">
						<PolicyItem
							:key="item.plcyId"
							:policy="item"
							:listSelectedPolicy="listSelectedPolicy"
							:listSelectedRule="listSelectedRule"
							:currentCmpnId="currentCmpnId"
							@onChecked="onChecked"
							@onCheckedRule="onCheckedRule"
						/>

					</tr>
					</tbody>
				</table>
			</div>
			<Pagination v-if="plcyList.length != 0"
				:callSetCurPage="callSetCurPage"
				:callSetRowsPerPage="callSetRowsPerPage"
				:currentPage="paging.currentPage"
				:rowsPerPage="paging.rowPerPage"
				:totalPage="paging.totalPage"
			/>
			
		</div>
	</div>
</template>
<script>
import Pagination from "../../common/Pagination.vue"
import PolicyItem from "../policyComponents/PolicyItem.vue"
export default {
	name: "ImportRuleForm",
	components: {Pagination, PolicyItem},
	data() {
		return {
			srchText: "",
			sortNum: 1,
			listSelectedPolicy: [],
			isCheckAll: false,
			listItemValue: [],
			sortOrder: "",
			listSelectedRule: [],
			isLoading: false,
			plcyList: [],
			paging: {
                rowPerPage: 10,
                currentPage: 1,
            },
		}
	},
	props: {
		currentCmpnId: {
			type: String,
			default: ""
		}
	},
	created() {
		this.getPolicies();
		this.debounceGetPolicies = _.debounce(this.getPolicies, 300);
	},
	computed: {
		getLocale: function () {
            return this.$i18n.locale
        }
	},
	methods: {
		fnSearching() {
			this.debounceGetPolicies();
		},
		onChecked(policy) {
			let index = _.findIndex(this.listSelectedPolicy, function(o) { return o.plcyId == policy.plcyId; });
			if (index === -1) {
				this.listSelectedPolicy.push(policy);
			} else {
				this.listSelectedPolicy.splice(index, 1);
			}
			this.setCheckAll();
			this.callSetSelectValue();
		},
		onCheckedRule(result) {
			let index = _.findIndex(this.listSelectedRule, function(o) { return o.plcyId == result.plcyId; });
			if (index !== -1) {
				this.listSelectedRule.splice(index, 1);
			}
			if (!result.isCheckAll) {
				this.listSelectedRule.push(result);
			} 
			this.setCheckAll();
			this.callSetSelectValue();
		},
		onCheckAll() {
			if (this.isCheckAll) {
				let _this = this;
				this.plcyList.forEach((value) => {
					let idx = _.findIndex(_this.listSelectedPolicy, function(o) { return o.plcyId == value.plcyId; });
					if (idx !== -1) {
						_this.listSelectedPolicy.splice(idx, 1);
					}
				});
			} else {
				let _this = this;
				this.plcyList.forEach((value) => {
					let idx = _.findIndex(_this.listSelectedPolicy, function(o) { return o.plcyId == value.plcyId; });
					if (idx === -1) {
						_this.listSelectedPolicy.push(value);
					}
				});
			}
			this.callSetSelectValue();
		},
		setCheckAll() {
			let checkAll = true;
			(this.plcyList || []).forEach(item => {
				let idx = _.findIndex(this.listSelectedPolicy, function(o) { return o.plcyId == item.plcyId; });
				if (idx === -1){
					checkAll = false;
					return;
				}
			});
			this.isCheckAll = checkAll;
		},
		callSetSelectValue() {
			let ruleIds = [];
			let rules = [];
			this.listSelectedRule.forEach(e => {
				ruleIds = ruleIds.concat(e.ruleIds);
				rules = rules.concat(e.rules);
			});
			this.$emit('callSetSelectValue', {policys: this.listSelectedPolicy, ruleIds: ruleIds, rules: rules});
		},
		callSetSortColumn(sortNum) {
			sortNum++;
			if (sortNum > 3) {
				sortNum = 1;
				this.sortOrder = "";
				this.plcyList = _.cloneDeep(this.rootListItem);
			} else if (this.sortOrder == "asc") {
				this.sortOrder = "";
				this.plcyList = _.orderBy(this.plcyList, ['titl'], ['desc']);
			} else {
				this.sortOrder = "asc";
				this.plcyList = _.orderBy(this.plcyList, ['titl'], ['asc']);
			}
			this.sortNum = sortNum;
		},
		getVender(vender) {
			vender = (vender || "").toLowerCase();
			if (vender == 'azu') {
				vender = 'azure';
			}
			return vender;
		},
		async getPolicies() {
			this.isLoading = true;
            const url = "/api/governance/policy/list";
            const header = {
                "cmpnId": this.currentCmpnId,
                "srchText": this.srchText,
                "rowPerPage": this.paging.rowPerPage,
                "currentPage": this.paging.currentPage,
                "isLimitPage": true,
                "statusFilter": ["FU", "FS", "P", "R", "E", "N"],
                "slctVendors": []
                }
            const response  = await this.http.post(url, JSON.stringify(header));
            if (response.data.status != 'fail') {
                let plcyList = response.data.result;
                this.paging = response.data.pagination;
                 _.forEach(plcyList, (p) => {                        
                    p.vendors = JSON.parse(p.vendorsjs);
                    p.transTitl = p.userDefiYn === this.constants.PARAM.SELECT.N ? p[this.getLocale + 'Title'] : p.titl;
                    p.transDesc = p.userDefiYn === this.constants.PARAM.SELECT.N ? p[this.getLocale + 'Desc'] : p.desc;
                    p.transRemd = p.userDefiYn === this.constants.PARAM.SELECT.N ? p[this.getLocale + 'Remd'] : p.remd;
                 });
                this.plcyList = plcyList;
            }
			this.setCheckAll();
            this.isLoading = false;
        },
		callSetRowsPerPage(rpp) {
            this.paging.currentPage = rpp.currentPage;
            this.paging.rowPerPage = rpp.rowsPerPage;
            this.debounceGetPolicies();
        },
        callSetCurPage(e) {
            this.paging.currentPage = e;
            this.debounceGetPolicies();
        },
	}
}
</script>

<style scoped lang="scss">
/deep/ .ag-body-viewport.ag-layout-normal.ag-row-no-animation.ag-body {
	overflow-x: hidden;
	overflow-y: auto;
}

/deep/ .ag-body-viewport.ag-layout-normal.ag-row-no-animation.ag-body::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

/deep/ .ag-body-viewport.ag-layout-normal.ag-row-no-animation.ag-body::-webkit-scrollbar
{
	width: 8px;
	background-color: #F5F5F5;
}

/deep/ .ag-body-viewport.ag-layout-normal.ag-row-no-animation.ag-body::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #989fa9;
}
/deep/ .ag-body-horizontal-scroll-viewport {
	overflow-x: hidden;
}
/deep/ .ag-header-viewport {
    background-color: #f6f8fa;
    color: #6e6e6e;
}
/deep/ .ag-header-cell-label {
    border-right-width: 1px;
    border-right-style: solid;
    margin-right: 10px;
    border-right-color: gray;
}
.custom-pagination.-pagination {
	position: inherit;
}
span.rule-title {
	display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: calc(100% - 20px);
	width: 500px;
}
.rule-description {
	display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
	width: 550px;
}
.description {
	border-left: none;
}
.float-left {
	float: left;
}
.vertical-align-baseline {
	vertical-align: baseline !important;
}
.table-rule {
	height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/policy/policyComponents/ImportRuleForm.vue